import React,{useState,useEffect} from 'react';
import { MDBInput } from "mdb-react-ui-kit";
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import {
  Card, 
  CardBody,
  Row,
  Col,
  Input,
  FormGroup,
  UncontrolledTooltip,
  Button,
  Label
} from "reactstrap";
import axios from 'axios';
import {SEND_SMS,CHANNEL_CLIENT_CHNLTYPE} from "../../constants"
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import apiService from '../../variables/apiService';

let templates = [];
let senderids = [];

  var initialvalues = {
    user: "",
    password: "",
    peid: "",
    templateid: "",
    sender: "",
    dest: "",
    messagetype: "",
    message: "",
    deliveryreport: ""
  }
const InstantSms = () => {
  

  const [smsdata, setsmsdata] = useState(initialvalues);
  const [channel, setChannel] = useState([]);

  const [count, setCount] = React.useState(0);
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorhandle,setErrorHandle]= useState()
  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  useEffect(()=>{
    fetchChanelsbyClient();
  },[])

  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"sms",
      clintId:user?.client
    }
    user?.client!=0&&(await apiService.postData(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
      templates=[]
      const chnlObj = res?.data[0]
      setChannel(res?.data)
      
      setsmsdata({...channel,peid:chnlObj.peid,user:localStorage.getItem("username"),password:localStorage.getItem("password")})
 
      res?.data?.map((item,i)=>{
        item?.template&& templates.push({ value: item?.template, label: item?.name?item?.template+" ( "+item?.name+")" :item?.template});
        
      })
      
      setIsLoading(false)
     }).catch(e=>{
      setIsLoading(false)
      let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }
  
  const changeSender=(data)=>{
    senderids=[]
    const chnl=channel?.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }

    setsmsdata(prev=>({...prev,templateid:data,sender:"",message: chnl[0]?.content,messagetype:chnl[0]?.sms_type}))
  }
  const submitFields = ()=>{
    const isValid=validate();
    setErrorHandle(isValid)
    console.log(isValid);
    if(Object.keys(isValid).length==0){
      
     let payload={
    user: smsdata?.user,
    password: smsdata?.password,
    peid: smsdata?.peid,
    templateid: smsdata?.templateid?.value,
    sender: smsdata?.sender?.value,
    dest: smsdata?.dest,
    messagetype: smsdata?.messagetype,
    message: smsdata?.message,
    deliveryreport: "yes"
  }
  
     apiService.postData(SEND_SMS, payload).then((response) => {
   
      let options = {};
      options = {
        place: "tr",
        message: "Sent Successfully",
        type: "success",

        autoDismiss: 2,
      };
      setsmsdata({...smsdata,
        templateid: "",
        sender: "",
        dest: "",
        messagetype: "",
        message: "",
        deliveryreport: ""
      });
      

     notificationAlertRef.current.notificationAlert(options);
   
     }).catch(err=>{
      console.log("err==>",err)
      let options = {};
      options = {
        place: "tr",
        message: (err?.response?.data?.Status||err?.response?.data?.message),
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
     });
    }
  }
  const validate=()=>{
    const num = smsdata?.dest?.split("")[0];
    let error={}
    if(!smsdata?.dest?.trim()){
      error.dest="Please enter Mobile Number"
    }else if(smsdata?.dest?.length!=10){
      error.dest="Mobile Number Should be 10 digits"
    }else if(num<=5||num=="-"||num=="+"||num=="e"){
      error.dest=`Number should not starts with ${num}`
    }
    if(!smsdata?.templateid){
      error.templateid="Please Select Template"
    }
    if(!smsdata?.sender){
      error.sender="Please Select Sender"
    }
    if(!smsdata?.message?.trim()){
      error.message="Please enter message"
    }
    if(!smsdata?.messagetype){
      error.messagetype="Please select message type"
    }
    
    return error;
  }
  return (
    <div className='content'>
        <Card>
            <CardBody>
            <Row className="mb-4 ">
      <NotificationAlert ref={notificationAlertRef} />
      <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
        <Col md="4" sm="12" className="mt-4 " >
          
          <MDBInput label="Mobile No *" type="number" value={smsdata.dest} name="mobileno" placeholder="9876543210"  onChange={(e)=>{
            setsmsdata({...smsdata,dest: e.target.value})
            console.log(smsdata?.dest?.length);
            }} />
          {errorhandle?.dest&&<span style={{color:"red"}}>{errorhandle?.dest}</span>}
        </Col>
        <Col md="4" sm="12">
          <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={smsdata.templateid}
            onChange={(value) => changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
        <Col md="4" sm="12">
          <p className="category">Select Sender<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={smsdata?.sender}
            onChange={(value) => setsmsdata(prev=>({...prev,sender:value}))}
            options={senderids}
            placeholder="Select"
          />
           {errorhandle?.sender&&<span style={{color:"red"}}>{errorhandle?.sender}</span>}
        </Col>
      
        <Col md="4" sm="12">
          <label>Message <suf style={{color:"red"}}>*</suf> </label>
          <FormGroup>
            <Input type="textarea" placeholder="Enter Message" style={{ padding: "5px", resize:"auto",maxHeight:"none" }}
            maxLength={160}
            value={smsdata?.message} onChange={e => {setsmsdata(prev=>({
           ...prev,message: e.target.value
          }));
         // setCount(e.target.value.length)
        }}
           />
            {/* <label style={{float:"right"}}>{count} / 160</label> */}
          </FormGroup>
          {errorhandle?.message&&<span style={{color:"red"}}>{errorhandle?.message}</span>}
        </Col>
        <Col  md="4" sm="12">
        <label>Message Type <suf style={{color:"red"}}>*</suf> </label>
          <FormGroup>
            <Input type='text' value={smsdata?.messagetype} disabled="true"/>
        </FormGroup>
        </Col>
        {/* <Col md="4" sm='12'>
                  <FormGroup check className="form-check-radio" inline>
      
      <Label check>
      <Input
       defaultValue="T"
       id="exampleRadios3"
       name="exampleRadio"
       type="radio"
       value="T"
       checked={smsdata?.messagetype == "T"}
       onChange={(value) =>{setsmsdata({...smsdata,messagetype:"T"})
      
     }}
     />
     <span className="form-check-sign" />
     Text Message
   </Label>
 </FormGroup>
 <FormGroup check className="form-check-radio" inline>
      <Label check>
      <Input
       
       id="exampleRadios4"
       name="exampleRadio"
       type="radio"
       value="U"
       checked={smsdata?.messagetype === "U"}
       onChange={(value) =>{setsmsdata({...smsdata,messagetype:"U"})
      
     }}
     />
     <span className="form-check-sign" />
     Unicode
   </Label>
  
 </FormGroup> {errorhandle?.messagetype&&<p style={{color:"red"}}>{errorhandle?.messagetype}</p>}
                  </Col> */}
        <Col md="3" sm="3">
          <Button
            color="primary "
            className="mt-4 btn btn-icon animation-on-hover"
            id="tooltipsubmit"
            type="button"
            onClick={()=>submitFields()}
          >
            <i className="tim-icons icon-double-right" />
          </Button>
         
        </Col>
      </Row>
            </CardBody>
        </Card>
    </div>
  )
}

export default InstantSms
